import Image from 'next/image';
import * as Accordion from '@radix-ui/react-accordion';
import { Icon, Button } from '@pairy/pds-react';

import { TriggerChevronIcon } from '@/styles/Accordion/ViewHistoryAccordion.styles';
import { logo } from '@/components/User/_components/pdf/BulkLogos/index.constants';

import * as Styled from '../../index.styles';
import useCopy from '../../useCopy';

const Stibee = () => {
  const copy = useCopy();

  return (
    <>
      <Accordion.Header>
        <Styled.AccordionTrigger>
          <Image
            src={logo.stibee.src}
            alt={logo.stibee.alt}
            width={logo.stibee.width}
            height={logo.stibee.height}
          />
          <TriggerChevronIcon icon="ph:caret-up" size={19} />
        </Styled.AccordionTrigger>
      </Accordion.Header>
      <Styled.AccordionContent>
        <Button
          type="button"
          width="100%"
          variant="skyblue_300"
          textVariant="md-medium"
          radius={8}
          paddingX={16}
          paddingY={12}
          InnerWrappeGap={4}
          marginTop={16}
          leftIcon={<Icon icon="ph:link" size={17} />}
          onClick={() => copy('stibee')}
        >
          Stibee용 링크 생성하기
        </Button>
      </Styled.AccordionContent>
    </>
  );
};

export default Stibee;
